import React, { memo } from 'react'
import {
  FormControlLabel,
  Box,
  Typography,
} from '@mui/material'
import Grid from '@mui/material/Grid2'
import { toggleValueFromString } from 'utils/universal'
import CheckIcon from 'public/img/easy/Check-icon.svg'
import sx from './styles'

const filterOptions = [
  { id: 'con-garantia', label: 'Con garantía', value: 'true' },
  { id: 'negociar-precio', label: 'Negociar precio', value: 'true' },
]

const WarrantyFilter = ({
  hasWarrantySelected,
  priceNegotiableSelected,
  onChange,
}) => {
  const handleChange = (label, item) => {
    if (label === 'Con garantía') {
      onChange(({ has_warranty: toggleValueFromString(hasWarrantySelected, item) }))
    } else {
      onChange(({ price_negotiable: toggleValueFromString(priceNegotiableSelected, item) }))
    }
  }

  const handleIsChecked = (label) => {
    if (label === 'Con garantía') {
      return hasWarrantySelected?.includes('true')
    }
    return priceNegotiableSelected?.includes('true')
  }

  return (
    <Grid
      container
      gap={1}
      sx={sx.root}
    >
      {filterOptions
        && filterOptions?.map(({ label, value }) => (
          <Grid
            size="grow"
            sx={sx.item}
            key={`warranty-${label}`}
          >
            <FormControlLabel
              sx={sx.field}
              control={(
                <Box sx={sx.checkContainer}>
                  {
                    (handleIsChecked(label)) ? (
                      <CheckIcon />
                    ) : (
                      <Box sx={sx.emptyCheck} />
                    )
                  }
                </Box>
              )}
              onClick={() => handleChange(label, value)}
              label={(
                <Typography
                  variant="button-text"
                  sx={sx.text}
                >
                  {label}
                </Typography>
              )}
            />

          </Grid>
        ))}
    </Grid>
  )
}

export default memo(WarrantyFilter)
